module.exports = __webpack_public_path__ + "2474ad0db0820863bf8c7b7982d3ca4c.pdf";